import React from 'react';
import {
  Button,
  View,
  Text,
  //  Modal,
  CloseButton,
  Heading,
  TextArea,
} from '@instructure/ui';
import { getStore, useCheckinStore } from '../../../stores/StoreContext';
import Modal from '../../Common/ModalContained';
/**
 * DenyConfirmation is a modal component that renders when the deny button
 * is clicked in the SessionDetails component.
 *
 * It prompts the user to confirm that they indeed want to deny the session.
 * If confirmed, it will call the `denySession` function in the checkin
 * store.
 *
 * @returns {JSX.Element} A Modal component with a header, body, and footer.
 */
const DenyConfirmation = () => {
  const CheckinStore = getStore('checkinStore');
  const LayoutStore = getStore('layoutStore');

  const isDenyConfirmationOpen = useCheckinStore(
    (state) => state.isDenyConfirmationOpen
  );

  const handleButtonClick = () => {};

  /**
   * Renders a CloseButton component for the modal header.
   *
   * This button, when clicked, will set the `isDenyConfirmationOpen`
   * state to false, effectively closing the deny confirmation modal.
   *
   * @returns {JSX.Element} A CloseButton component.
   */

  const renderCloseButton = () => {
    return (
      <CloseButton
        placement="end"
        offset="small"
        onClick={() => CheckinStore.setDenyConfirmationOpen(false)}
        screenReaderLabel="Close"
      />
    );
  };
  return (
    <Modal
      open={isDenyConfirmationOpen}
      label="Confirm Action"
      mountNode={LayoutStore.containers?.session?.element}
    >
      <Modal.Header>
        {renderCloseButton()}
        <Heading level="h3">Are you sure?</Heading>
      </Modal.Header>
      <Modal.Body>
        <View as="p" margin="none none small">
          <Text as="div">
            This session will be denied access and will automatically close
            down.
          </Text>
          <View as="div" margin="small none none none">
            <TextArea
              label="Reason"
              maxHeight="10rem"
              placeholder="Please provide details for why this session is being denied."
            />
          </View>
        </View>
      </Modal.Body>
      <Modal.Footer>
        <Button
          onClick={() => CheckinStore.setDenyConfirmationOpen(false)}
          margin="0 x-small 0 0"
        >
          Cancel
        </Button>
        <Button onClick={CheckinStore.denySession} color="danger" type="submit">
          Yes, Deny Session
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DenyConfirmation;
